import moment from 'moment';

export const buildQueryParams = (query) => {
    const result = {
    };
    if (query.has('clusterCount')) {
        result.clusterCount = query.get('clusterCount');
    }
    if (query.has('comparisonRateType')) {
        result.comparisonRateType = query.get('comparisonRateType');
    }
    if (query.has('origins')) {
        result.origins = query.getAll('origins');
    }
    if (query.has('refresh')) {
        result.refresh = query.get('refresh');
    }
    if (query.has('shipStartDate')) {
        result.shipStartDate = moment(query.get('shipStartDate')).format('YYYY-MM-DDTHH:mm:ss');
    }
    if (query.has('shipEndDate')) {
        result.shipEndDate = moment(query.get('shipEndDate')).format('YYYY-MM-DDTHH:mm:ss');
    }
    if (query.has('maxZone')) {
        result.maxZone = query.get('maxZone');
    }
    return result;
};
